import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  Optional,
  Renderer2,
  ViewChild,
  effect,
  input,
  Input,
  Output,
  EventEmitter,
  ViewChildren,
  QueryList,
  AfterViewInit,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, firstValueFrom, Observable, of } from 'rxjs';
import { distinctUntilChanged, filter, switchMap } from 'rxjs/operators';
import { MaterialModule } from 'src/app/material.module';
import { leadServices } from 'src/app/services/leads.service';
import { StepperPurecssComponent } from 'src/app/shared/stepper-purecss/stepper-purecss.component';
import { TabsComponent } from './tabs/tabs.component';
import { FormsModule } from '@angular/forms';
import { LeadInfoComponent } from './lead-info/lead-info.component';
import { NotesComponent } from './tabs/notes/notes.component';
import { environment } from 'src/environments/environment';
import { ActivityComponent } from './tabs/activity/activity.component';
import { tasksServices } from 'src/app/services/tasks.service';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CommunicationService } from './signal-lead.serice';
import { EmailSmsComponent } from './tabs/email-sms/email-sms.component';
import { CallsComponent } from './tabs/calls/calls.component';
import { ReasonModalComponent } from 'src/app/shared/lost-modal/reason-modal/reason-modal.component';
import { generalService } from 'src/app/services/general-info';
import { Status } from 'src/app/helper/enum';
import { DublicatedLeadComponent } from 'src/app/shared/dublicated-lead/dublicated-lead.component';
import { CustomDatePipe } from 'src/app/pipe/date-format.pipe';
import { ActionPageComponent } from 'src/app/shared/action-page/action-page.component';
import { DocumentsComponent } from './tabs/documents/documents.component';
import { FollowersButtonComponent } from 'src/app/shared/followers-button/followers-button.component';
import { MatButton } from '@angular/material/button';
import { LeadSkeletonLoaderComponent } from 'src/app/shared/loading-models/loading-lead-view';
import { DateComponent } from 'ag-grid-community/dist/types/core/components/framework/componentTypes';
import { ActivityModalDataService } from 'src/app/services/lead-activity-modal.service';
import { NotificationsService } from 'src/app/services/notifications/notifications.service';
import { CallFacadeService } from '@app/services/call';
import { CompactCallButtonComponent } from 'src/app/shared/compact-call-button/compact-call-button.component';
import { DialogComponent } from 'src/app/shared/dialog/confirm.dialog';
import { STEP_TYPES } from 'src/app/admissions/pipelines/step-add-edit/step-add-edit.component';
import { CallFeatureService } from 'src/app/services/call-feature.service';
import { ActivityLogComponent } from './tabs/changing/activity-log.component';
import { SocketService } from 'src/app/services/socket.service';
import { CelebrationService } from '@app/shared/celebration/celebration.service';
import { EnrollmentModalComponent } from '@app/shared/enrollment-modal/enrollment-modal.component';
import { ActivityLeadService } from '@app/services/lead-activity.servise';
import { AiSummaryComponent } from '../ai/ai-summary/ai-summary.component';

@Component({
  selector: 'app-leads-managment',
  standalone: true,
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    StepperPurecssComponent,
    TabsComponent,
    LeadInfoComponent,
    CustomDatePipe,
    ActionPageComponent,
    FollowersButtonComponent,
    MatButton,
    LeadSkeletonLoaderComponent,
    CompactCallButtonComponent,
    AiSummaryComponent
  ],
  templateUrl: './leads-managment.component.html',
  styleUrls: ['./leads-managment.component.scss','./lead-managment.component-modal.scss','./shared-style.scss','./empty-spaces.scss','./modal-specific-fixes.scss', './inline-edit.scss'],
})
export class LeadsManagmentComponent implements OnInit, OnDestroy, AfterViewInit {

  tabs: any[] = []; // Will be initialized in ngOnInit based on call feature flag

  // Track call feature status
  callsEnabled: boolean = false;

  private leadSubject = new BehaviorSubject<any | null>(null); // Holds the lead state
  receivedData = this.communicationService.data;
  lead$: Observable<any | null> = this.leadSubject.asObservable();
  id: any;
  isModal: boolean = false;
  isDropdownOpen = false;
  duplicated:boolean = false
  shouldResetTabs: boolean = false;
  leadDosNotExist:boolean=false
  last_activity_time: any;
  isDashboardView:boolean=false

  private leadUpdateSubscription: Subscription | null = null;
  private currentSubscribedLeadId: number | null = null;

  @ViewChild(StepperPurecssComponent) stepper!: StepperPurecssComponent;


  previousId: number | null = null;
  nextId: number | null = null;
  leadList: any[] = [];
  @Input() dialogObject2: any;
  @Input() isEmbedded: boolean = false;
  @Output() leadUpdated = new EventEmitter<any>();
  @Output() closeDialog = new EventEmitter<any>();
  private isUpdatingFromService = false;
  private outsidePhoneClickUnlisten: (() => void) | null = null; // ✅ add this

  lastLeadRequest: any = null;
  navigationLoading = false;

  // New properties for inline editing
  editingField: string | null = null;
  editValue: any = '';
  editPrefix: string = '';
  editPhoneNumber: string = '';   // NEW: separate phone number field
  originalName: string = '';
  originalLastName: string = '';
  pendingSave: boolean = false;
  
  // Properties for hover state
  hoveredField: string | null = null;

  @ViewChild('nameInput') nameInput!: ElementRef;
  @ViewChild('emailInput') emailInput!: ElementRef;
  @ViewChild('phoneInput') phoneInput!: ElementRef;

  @ViewChild('phoneEditContainer') phoneEditContainer!: ElementRef;
  @ViewChild('prefixInput') prefixInput!: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private leadsService: leadServices,
    private taskService: tasksServices,
    private communicationService: CommunicationService,
    private modalDataService: ActivityModalDataService,
    private notificationService: NotificationsService,
    private calls: CallFacadeService,
    private dialog: MatDialog,
    private renderer: Renderer2,
    private callFeatureService: CallFeatureService,
    private socketService: SocketService,  // ADD THIS
    private celebrationService: CelebrationService,  // ADD THIS
    private activityLeadService: ActivityLeadService,  // ADD
    @Optional() public dialogRef: MatDialogRef<LeadsManagmentComponent>,
    @Inject(MAT_DIALOG_DATA) @Optional() public dialogObject: any,
  ) {
    effect(() => {
      const newData = this.receivedData(); // Access the signal's value
      this.onDataReceived(newData); // Trigger your function
    });

    if (dialogRef) {
      this.dialogRef.beforeClosed().subscribe(() => {
        // Reset the signal when the modal closes
        this.communicationService.resetSignal();
      });
    }
  }

  @ViewChild('scrollableContainer') scrollableContainer!: ElementRef;
  private subscription= new Subscription();

  ngOnInit() {
    // Subscribe to call feature status
    this.subscription.add(
      this.callFeatureService.callsEnabled$.subscribe(enabled => {
        this.callsEnabled = enabled;

        // Initialize tabs based on call feature status
        this.initializeTabs();
      })
    );

    if (this.isEmbedded) {
      // When embedded in ActivityLeadManagementComponent, use the shared service
      this.initializeFromService();
    } else if (this.dialogObject?.data) {
      // Dialog mode
      this.initializeFromDialog();
    } else {
      // Standalone route mode
      this.initializeFromRoute();
    }


    // Listen for task updates
    this.subscription.add(this.taskService.result$.subscribe((result) => {
      if (result && result.editMode) {
        return;
      }

      this.scrollToTopOfContainer();
    }));

    this.subscription.add(this.modalDataService.activityEvents$
    .subscribe((activityEvent: any) => {
      if (!activityEvent) { return; }
      const currentLead = this.leadSubject.getValue();
      if (!currentLead) { return; }
      const tasks = currentLead.tasks || [];
      const incoming = activityEvent.data;
      const incomingId = incoming?.id;
      const exists = incomingId != null && tasks.some((task: any) => task.id === incomingId);

      let updatedTasks = tasks;


      if (incoming?.newAppointment || incoming?.newTask || incoming?.oldTask) {
        // Get the old task ID to match against
        const oldTaskId = incoming?.oldTask?.data?.id || incoming?.oldTask?.id;
        const oldTaskData = incoming?.oldTask?.data || incoming?.oldTask;

        // Replace the old task with updated data and add the new task
        updatedTasks = [
          ...tasks.map((task: any) =>
            task.id === oldTaskId ? { ...oldTaskData } : task
          ),
          incoming.newTask
        ].filter(Boolean);
      }
      // Update: patch in place when present. If the task was previously
      // removed from focus (e.g. while marked complete) and is now
      // un-completed, add it back so focus reflects the new state.
      else if (activityEvent.action === 'update') {
        if (exists) {
          updatedTasks = tasks.map((task: any) =>
            task.id === incomingId ? { ...task, ...incoming } : task
          );
        } else if (
          incomingId != null &&
          incoming?.completed === false &&
          incoming?.active !== false
        ) {
          updatedTasks = [...tasks, incoming];
        }
      }
      // Delete: remove if present, never add.
      else if (activityEvent.action === 'delete') {
        if (exists) {
          updatedTasks = tasks.filter((task: any) => task.id !== incomingId);
        }
      }
      // Create: add only if not already present.
      else if (activityEvent.action === 'create') {
        if (!exists && incomingId != null) {
          updatedTasks = [...tasks, incoming];
        }
      }

      // Skip the round-trip if nothing actually changed (avoids feedback loops
      // through setLeadDataAndSync → modalDataService.setLeadData).
      if (updatedTasks === tasks) { return; }

      const updatedLead = {
        ...currentLead,
        tasks: updatedTasks,
        ...(activityEvent.action == 'create' && { last_activity_time: new Date() })
      };

      this.setLeadDataAndSync(updatedLead);
    }));

    // Subscribe to lead updates (e.g., when lead is closed via outcome selection)
    this.subscription.add(
      this.modalDataService.leadUpdatesEvents$.subscribe((updatedLeadData: any) => {
        if (!updatedLeadData) return;

        const currentLead = this.leadSubject.getValue();
        if (!currentLead || updatedLeadData.id !== currentLead.id) {
          return;
        }

        // Merge lead-level fields, but preserve tab-managed collections.
        // `getOne` returns a full lead with server-side filtered/scoped
        // tasks/notes/messages, which would clobber the lists the Activity,
        // Note, and Messages tabs maintain locally and make sibling rows
        // disappear (e.g. after mark-as-lost / enroll outcomes).
        const mergedLead = {
          ...currentLead,
          ...updatedLeadData,
          tasks: currentLead.tasks ?? updatedLeadData.tasks,
          note: currentLead.note ?? updatedLeadData.note,
          messages: currentLead.messages ?? updatedLeadData.messages,
        };
        this.setLeadDataLocally(mergedLead);
      })
    );
  }

  /**
   * Initialize from ActivityModalDataService (when embedded)
   */
  private initializeFromService() {
    this.isModal = false;
    
    const leadData = this.modalDataService.getCurrentLeadData();
    if (leadData) {
      this.setLeadDataLocally(leadData);
      
      // ========== ADD THIS ==========
      // Subscribe to lead room for real-time updates
      this.subscribeToLeadRoom(leadData.id);
      // ==============================
    }


    this.subscription.add(
      this.modalDataService.leadData$.pipe(
        filter(leadData => leadData !== null), // Filter out null values
        distinctUntilChanged((prev, curr) => {
          // Prevent updates if data hasn't actually changed
          return JSON.stringify(prev) === JSON.stringify(curr);
        })
      ).subscribe(leadData => {
        if (!this.isUpdatingFromService) { // Prevent circular updates
          this.isUpdatingFromService = true;
          this.setLeadDataLocally(leadData); // Only update local state
          this.isUpdatingFromService = false;
        }
      })
    );
  }

  /**
   * Initialize tabs based on call feature status
   */
  private initializeTabs(): void {
    this.tabs = [
      {
        label: 'Messages',
        component: EmailSmsComponent,
        api: `${environment.apiUrl}/messages`,
        forwardLeadAllowed: true,
        params: {
          pageIndex: 1,
          pageSize: 10,
          sortField: 'created_at',
          sortDirection: 'desc',
          showArchive: false,
        },
      },
      {
        label: 'Note',
        component: NotesComponent,
        api: `${environment.apiUrl}/notes`,
        forwardLeadAllowed: true,
        params: {
          pageIndex: 1,
          pageSize: 10,
          sortField: ['pined', 'created_at'],
          sortDirection: ['DESC', 'DESC'],
          showArchive: false,
        },
      },
      {
        label: 'Activity',
        component: ActivityComponent,
        forwardLeadAllowed: true,
        api: `${environment.apiUrl}/tasks/getAllActivities`,
        params: {
          pageIndex: 1,
          pageSize: 10,
          sortField: 'startDate',
          sortDirection: 'desc',
          userTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
      },
    ];

    // Conditionally add Calls tab only if calls are enabled
    if (this.callsEnabled) {
      this.tabs.push({
        label: 'Calls',
        component: CallsComponent,
        api: `${environment.apiUrl}/calls`,
        forwardLeadAllowed: true,
        params: {
          pageIndex: 1,
          pageSize: 10,
          sortField: 'id',
          sortDirection: 'desc',
          showArchive: false,
        }
      });
    }

    // Continue with other tabs
    this.tabs.push(
      {
        label: 'Documents',
        component: DocumentsComponent,
        api: `${environment.apiUrl}/documents/lead_document`,
        forwardLeadAllowed: true,
        params: {
          pageIndex: 1,
          pageSize: 100,
          sortField: 'id',
          sortDirection: 'desc',
          showArchive: false,
        }
      },
      {
        label: 'Changelog',
        component: ActivityLogComponent,
        forwardLeadAllowed: true,  // Changed to true to pass lead
        api: `${environment.apiUrl}/general/activityLogs`,  // New endpoint
        params: {
          pageIndex: 1,
          pageSize: 10,
        },
      }
    );

  }

  /**
   * Initialize from route parameters (standalone mode)
   */
  private initializeFromRoute() {
    this.isModal = false;
  
    const savedRequest = localStorage.getItem('last-lead-request');
    if (savedRequest) {
      this.lastLeadRequest = JSON.parse(savedRequest);
    }
    
    this.route.params
      .pipe(
        switchMap((params) => {
          this.id = params['id'];
          return this.id ? this.leadsService.getOne(this.id) : of({});
        }),
      )
      .subscribe((lead) => {
        if (!lead || Object.keys(lead).length === 0) {
          this.leadDosNotExist = true;
          this.leadSubject.next({});
        } else {
          this.duplicated = lead?.isDuplicated || false;
          this.last_activity_time = lead?.last_activity_time;
          this.leadSubject.next(lead);
          this.loadNavigation();
          
          // ========== ADD THIS ==========
          // Subscribe to lead room for real-time updates
          this.subscribeToLeadRoom(lead.id);
          // ==============================
        }
      }, error => {
        console.error('Error fetching lead:', error);
        this.leadDosNotExist = true;
        this.leadSubject.next({});
      });
  }

  /**
   * Initialize from dialog data
   */
  private initializeFromDialog() {
    this.isModal = true;
    
    this.dialogRef.backdropClick().subscribe(() => {
      this.communicationService.resetSignal();
      this.dialogRef.close(this.leadSubject.getValue());
    });
  
    this.setLeadData(this.dialogObject.data);
    
    // ========== ADD THIS ==========
    // Subscribe to lead room for real-time updates
    this.subscribeToLeadRoom(this.dialogObject.data.id);
    // ==============================
    
    if (this.dialogObject.isDashboardView) {
      this.isDashboardView = true;
    }
  }

  /**
   * Set lead data and update both local state and service (if embedded)
   */
  private setLeadData(leadData: any) {
    this.id = leadData.id;
    this.duplicated = leadData?.isDuplicated || false;
    this.last_activity_time = leadData?.last_activity_time;
    
    this.leadSubject.next(leadData);

    // Update service if embedded (for cross-tab data sharing)
    if (this.isEmbedded) {
      this.modalDataService.setLeadData(leadData);
    }
    // Get lastLeadRequest from dialog data and load navigation only if isLeadView is true
    if (this.dialogObject.lastLeadRequest && this.dialogObject.isLeadView) {
      this.lastLeadRequest = this.dialogObject.lastLeadRequest;
        // Load navigation for modal only if opened from lead view
      this.loadNavigation();
    }
  }

   /**
   * Set lead data ONLY locally (no service update)
   */
  private setLeadDataLocally(leadData: any) {
    this.id = leadData.id;
    this.duplicated = leadData?.isDuplicated || false;
    this.last_activity_time = leadData?.last_activity_time;
    
    this.leadSubject.next(leadData);
  }

  /**
   * Set lead data and optionally update service (only when user makes changes)
   */
  private setLeadDataAndSync(leadData: any) {
    this.setLeadDataLocally(leadData);

    if (this.isModal) {
      this.modalDataService.emitLeadUpdate(leadData);
    }

    // Only update service if embedded AND not currently updating from service
    if (this.isEmbedded && !this.isUpdatingFromService) {
      this.modalDataService.setLeadData(leadData);
    }

    

  }
  // Add new method to load navigation
  private loadNavigation() {
    if (!this.lastLeadRequest) {
      return;
    }
  
    this.navigationLoading = true;
    this.leadsService.getLeadNavigation(this.id, this.lastLeadRequest)
      .subscribe({
        next: (navigation) => {
          this.previousId = navigation.previousId;
          this.nextId = navigation.nextId;
          this.navigationLoading = false;
        },
        error: (error) => {
          console.error('Error loading navigation:', error);
          this.navigationLoading = false;
        }
      });
  }

  scrollToTopOfContainer(): void {
    this.scrollableContainer.nativeElement.scrollTo({
      top: 0,
      behavior: 'smooth', // Smooth scrolling effect
    });
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.editingField === 'name' && this.nameInput?.nativeElement) {
        this.nameInput.nativeElement.focus();
        this.nameInput.nativeElement.select();
      } else if (this.editingField === 'email' && this.emailInput?.nativeElement) {
        this.emailInput.nativeElement.focus();
        this.emailInput.nativeElement.select();
      } else if (this.editingField === 'phone') {
        // Prefer focusing phone number; if not ready yet, focus prefix
        if (this.phoneInput?.nativeElement) {
          this.phoneInput.nativeElement.focus();
          this.phoneInput.nativeElement.select?.();
        } else if (this.prefixInput?.nativeElement) {
          this.prefixInput.nativeElement.focus();
          this.prefixInput.nativeElement.select?.();
        }
      }
    }, 0);
  }
  onFieldHover(field: string) {
    if (!this.editingField && !this.pendingSave) this.hoveredField = field;
  }
  onFieldLeave(field: string) {
    if (this.hoveredField === field) this.hoveredField = null;
  }



  cancelEdit() {
    this.editingField = null;
    this.editValue = '';
    this.editPrefix = '';
    this.editPhoneNumber = '';
    this.pendingSave = false;
  
    // ✅ ensure we clean up any global listener
    this.removeOutsideClickListener();
  }

  private validateEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  private validatePhone(phone: string): boolean {
    const digitsOnly = (phone || '').replace(/\D/g, '');
    return digitsOnly.length >= 7 && digitsOnly.length <= 15;
  }

  digitsOnly(event: KeyboardEvent) {
    const key = event.key;
    if (!/^\d$/.test(key)) {
      event.preventDefault();
    }
  }
  
  onPhoneNumberInput(event: any) {
    const raw = (event?.target?.value || '').toString();
    const digits = raw.replace(/\D/g, '').slice(0, 15);
    this.editPhoneNumber = digits;
    // keep the input's visible value in sync (in case of paste)
    if (event?.target && event.target.value !== digits) {
      event.target.value = digits;
    }
  }

  private setupOutsideClickForPhone() {
    this.removeOutsideClickListener();
  
    this.outsidePhoneClickUnlisten = this.renderer.listen('document', 'mousedown', (evt: MouseEvent) => {
      if (this.editingField !== 'phone') return;
      const target = evt.target as Element;
      const container = this.phoneEditContainer?.nativeElement;
      if (target.closest('snack-bar-container, .mat-mdc-snack-bar-container, .mat-mdc-button')) return;
      if (container && !container.contains(target)) {
        this.saveEdit('phone');
      }
    });
  }
  
  private removeOutsideClickListener() {
    if (this.outsidePhoneClickUnlisten) {
      this.outsidePhoneClickUnlisten();
      this.outsidePhoneClickUnlisten = null;
    }
  }
  

  private normalizePrefix(prefix: string | undefined | null, fallback = '+1'): string {
    let p = (prefix || '').trim();
    if (!p) return fallback;
    // Keep +, remove spaces, ensure digits only after +
    p = p.replace(/\s+/g, '');
    if (!p.startsWith('+')) p = `+${p}`;
    // Allow up to 4 digits in country code (loose)
    const m = p.match(/^\+(\d{1,4})$/);
    return m ? p : fallback;
  }

  startEdit(field: string, value: any, event?: Event) {
    if (event) event.stopPropagation();
    if (this.pendingSave) return;
  
    const currentLead = this.leadSubject.getValue();
    this.editingField = field;
    this.hoveredField = null;
  
    switch (field) {
      case 'name': {
        const nameParts = (value || '').split(' ');
        this.originalName = nameParts[0] || '';
        this.originalLastName = nameParts.slice(1).join(' ') || '';
        this.editValue = value || '';
        break;
      }
      case 'email': {
        this.editValue = value || '';
        break;
      }
      case 'phone': {
        // Normalize prefix but do NOT auto-close on mouse move anymore
        this.editPrefix = this.normalizePrefix(currentLead?.prefix, '+1');
        // Preload number as digits only, capped to 10
        this.editPhoneNumber = (currentLead?.phoneNumber || '').replace(/\D/g, '').slice(0, 15);
  
        // ✅ Close only when clicking outside
        this.setupOutsideClickForPhone();
        break;
      }
    }
  
    setTimeout(() => this.ngAfterViewInit(), 0);
  }
  


  async saveEdit(field: string) {
    if (!this.editingField || this.pendingSave) return;
  
    const currentLead = this.leadSubject.getValue();
    let updateData: any = {};
    let hasChanges = false;
  
    switch (field) {
      case 'name': {
        const nameParts = (this.editValue || '').trim().split(' ');
        const newFirstName = nameParts[0] || '';
        const newLastName = nameParts.slice(1).join(' ') || '';
      
        if (newFirstName !== this.originalName || newLastName !== this.originalLastName) {
          // ── confirmation dialog ──────────────────────────────
          const confirmed = await firstValueFrom(
            this.dialog.open(DialogComponent, {
              width: '350px',
              data: {
                header: 'Update Name',
                content: `Are you sure you want to rename this lead to "${(newFirstName + ' ' + newLastName).trim() || 'empty'}"?`,
                confirmText: 'Yes, Update',
                cancelText: 'Cancel',
              },
            }).afterClosed()
          );
          if (!confirmed) {
            this.cancelEdit();
            return;
          }
          // ────────────────────────────────────────────────────
      
          updateData.name = newFirstName;
          updateData.lastName = newLastName;
          hasChanges = true;
        }
        break;
      }
  
      case 'email': {
        const trimmedEmail = (this.editValue || '').trim();
        if (trimmedEmail && !this.validateEmail(trimmedEmail)) {
          this.notificationService.showNonErrorSnackBar('Please enter a valid email address', 3000);
          return; // keep edit mode
        }
        if (trimmedEmail !== currentLead.email) {
          updateData.email = trimmedEmail || null;
          hasChanges = true;
        }
        break;
      }
  
      case 'phone': {
        const digits = (this.editPhoneNumber || '').replace(/\D/g, '').slice(0, 15);
        this.editPhoneNumber = digits;
      
        const prefix = this.normalizePrefix(this.editPrefix || currentLead?.prefix, currentLead?.prefix || '+1');
        const phone = digits;
      
        if (!phone) {
          this.cancelEdit();
          return;
        }
        if (!this.validatePhone(phone)) {
          this.notificationService.showNonErrorSnackBar('Please enter a valid phone number (7–15 digits)', 3000);
          this.cancelEdit();
          return;
        }
      
        if (phone !== currentLead.phoneNumber || prefix !== currentLead.prefix) {
          updateData.phoneNumber = phone;
          updateData.prefix = prefix;
          hasChanges = true;
        }
        break;
      }
    }
  
    if (!hasChanges) {
      this.cancelEdit();
      return;
    }
  
    if (currentLead?.isDuplicated && (field === 'name' || field === 'email' || field === 'phone')) {
      this.notificationService.showNonErrorSnackBar(
        `You cannot update ${field} without merging this duplicated lead`,
        2500
      );
      this.cancelEdit();
      return;
    }
  
    this.pendingSave = true;
  
    try {
      updateData.company_id = currentLead.company_id;
      updateData.studentUserId = currentLead.student_user_id
      const response = await firstValueFrom(this.leadsService.put(updateData, this.id));

      if (response) {
        this.updateLead(response);
        this.notificationService.showNonErrorSnackBar('Updated successfully', 1800);
      }
    } catch (err) {
      const msg = this.extractErrorMessage(err);
      console.error('Error updating lead:', msg, err);
      this.notificationService.showNonErrorSnackBar(msg, 2500);
    }finally {
      this.cancelEdit(); // will also remove click listener
    }
  }
  

  onDataReceived(newSignal: any) {
    const currentLead = this.leadSubject.getValue();
    

    if (newSignal.type === 'sms-email') {
      if (currentLead) {
        const date_now = new Date()
        const updatedLead = { ...currentLead, messages: [], last_outgoing_message_time: date_now, last_activity_time: date_now };
        this.setLeadDataAndSync(updatedLead);
        this.last_activity_time = date_now;
      }
      return;
    }

    if (newSignal.type === 'focusActivityComponent') {
      const updatedLead = { ...currentLead, last_activity_time: new Date() };
      this.setLeadDataAndSync(updatedLead); // Sync to service
      return;
    }

    

    if (newSignal.type === 'close-email-modal') {
        if(this.isModal){
          this.communicationService.resetSignal(); // Reset signal when closing email modal
          this.dialogRef.close();
        }
    }

    if (newSignal.type === 'add-note') {
      const updatedLead = { ...currentLead, last_activity_time: new Date() };
      this.setLeadDataAndSync(updatedLead); // Sync to service
      return;
    }
    
    if (newSignal.type !== 'focus' || !newSignal.obj) return;

    if (!currentLead) return;

    const { location, data, update, updated, newNote, updateActivityTime } = newSignal.obj;
    const { id: dataId } = data;

    if (location === 'note') {
      const notes = currentLead.note || [];

      const updatedNotes = update
        ? notes.map((note: any) =>
            note.id === dataId ? { ...note, ...data } : note,
          )
        : notes.some((note: any) => note.id === dataId)
          ? notes.filter((note: any) => note.id !== dataId)
          : [...notes, data];
 

          const updatedLead = {
            ...currentLead,
            note: updatedNotes,
            ...(newNote && { last_activity_time: new Date() })
          };
          this.setLeadDataAndSync(updatedLead);
    }

  }

  updateLead(newLead: any) {
    if (newLead?.id) {
      this.leadsService.getOne(newLead.id).subscribe((updatedLead) => {
        this.setLeadDataAndSync(updatedLead); // This will sync to service
        
        // Emit update event for parent components
        this.leadUpdated.emit(updatedLead);
      });
    }
  }

  async LostPopUp() {
    const currentLead = this.leadSubject.getValue();
    
    // Check if lead is duplicated
    if (currentLead?.isDuplicated) {
      this.dialog.open(DialogComponent, { 
        width: '400px',
        data: {
          header: 'Cannot Mark as Lost',
          content: 'You cannot mark this lead as Lost without first resolving the duplicate. Please merge or separate the duplicated leads first.',
          isInfo: true,
          type: 'warning'
        }
      });
      return;
    }
  
    // Check if lead is enrolled
    if (currentLead?.enrolled_at) {
      this.dialog.open(DialogComponent, { 
        width: '400px',
        data: {
          header: 'Cannot Mark as Lost',
          content: 'You cannot mark an enrolled lead as Lost. Please unenroll the lead first if you need to change their status.',
          isInfo: true,
          type: 'warning'
        }
      });
      return;
    }
    
    // Original code continues...
    this.dialog.open(ReasonModalComponent, { width: '400px' })
      .afterClosed().subscribe(async (result) => {
        if (!result) return;
        result.status = 'Lost';
        const response = await firstValueFrom(this.leadsService.put(result, this.id));
        if (response) {
          const updatedLead = {
            ...this.leadSubject.getValue(),
            status: Status.LOST,
            lost_comment: response.lost_comment,
            lostReason: response.lostReason,
          };
          this.setLeadDataAndSync(updatedLead);
        }
      });
  }
  

  async reOpen() {
    try {
      const duplicateCheck = await firstValueFrom(
        this.leadsService.checkReopenDuplicates(this.id)
      );
  
      if (duplicateCheck.hasDuplicates) {
        const dialogRef = this.dialog.open(DialogComponent, {
          width: '450px',
          data: {
            header: 'Potential Duplicate Detected',
            content: `Reopening this lead will create a duplicate with ${duplicateCheck.duplicates.length} existing lead(s). Leads found will be marked as duplicated. Do you want to proceed?`,
            isInfo: false,
            type: 'warning',
            confirmText: 'Yes, Reopen',
            cancelText: 'Cancel'
          }
        });
  
        const confirmed = await firstValueFrom(dialogRef.afterClosed());
        if (!confirmed) return;
  
        const obj = {
          status: Status.DEAL,
          lost_comment: '',
          lost_reason: 0,
          forceReopen: true
        };
  
        const response = await firstValueFrom(this.leadsService.put(obj, this.id));
  
        if (response) {
          const updatedLead = {
            ...this.leadSubject.getValue(),
            status: Status.DEAL,
            isDuplicated: true,
            admission_status: response.admission_status ?? 'draft',
            current_step_id: response.current_step_id,
            step: response.step,
            last_step_change: response.last_step_change,
            last_activity_time: response.last_activity_time,
            enrolled_at: response.enrolled_at ?? null,
            start_at: response.start_at ?? null,
            completation_date: response.completation_date ?? null,
            lost_comment: '',
            lost_reason: null,
            lostReason: null,
          };

          this.setLeadDataAndSync(updatedLead);
          this.duplicated = true;
        }
      } else {
        const obj = {
          status: Status.DEAL,
          lost_comment: '',
          lost_reason: 0
        };
  
        const response = await firstValueFrom(this.leadsService.put(obj, this.id));
  
        if (response) {
          const updatedLead = {
            ...this.leadSubject.getValue(),
            status: Status.DEAL,
            admission_status: response.admission_status ?? 'draft',
            current_step_id: response.current_step_id,
            step: response.step,
            last_step_change: response.last_step_change,
            last_activity_time: response.last_activity_time,
            enrolled_at: response.enrolled_at ?? null,
            start_at: response.start_at ?? null,
            completation_date: response.completation_date ?? null,
            lost_comment: '',
            lost_reason: null,
            lostReason: null,
          };
          this.setLeadDataAndSync(updatedLead);
        }
      }
    } catch (error) {
      console.error('Error reopening lead:', error);
      this.notificationService.showNonErrorSnackBar('Error reopening lead', 2500);
    }
  }
  


  newStep(data: any) {
    const currentLead = this.leadSubject.getValue();
    if (currentLead) {
      const updatedLead = {
        ...currentLead,
        step: data?.step,
        current_step_id: data.step.id,
        last_activity_time: data?.last_activity_time,
        ...(data?.enrolled_at !== undefined && { enrolled_at: data.enrolled_at }),
        ...(data?.admission_status !== undefined && { admission_status: data.admission_status }),
        ...(data?.start_at !== undefined && { start_at: data.start_at }),
        ...(data?.status !== undefined && { status: data.status }),
        ...(data?.fa_advisor_id !== undefined && { fa_advisor_id: data.fa_advisor_id }),
        ...(data?.faAdvisor !== undefined && { faAdvisor: data.faAdvisor }),
      };

      this.setLeadDataAndSync(updatedLead);

      if (data?.step?.step_type === 'started') {
        this.celebrationService.celebrateWon();
      }
    }
  }


    async onTagsChanged(event: {action: 'add' | 'remove', tagId: number}) {
      const currentLead = this.leadSubject.getValue();
      if (!currentLead) return;
    
      try {
        let updatedTags: number[];
        const currentTagIds = (currentLead.lead_tags || []).map(lt => lt.tag_id);
    
        if (event.action === 'add') {
          updatedTags = [...currentTagIds, event.tagId];
        } else {
          updatedTags = currentTagIds.filter(id => id !== event.tagId);
        }
    
        const response = await firstValueFrom(
          this.leadsService.put({ tags: updatedTags }, this.id)
        );
    
        if (response) {
          this.updateLead(response);
        }
      } catch (err) {
        console.error('Error updating tags:', err);
        this.notificationService.showNonErrorSnackBar('Failed to update tags', 2500);
      }
    }

  async openDuplicatedLeadModal() {
    const currentLead = this.leadSubject.getValue();
    if(this.isEmbedded){
      this.dialogRef.close();
      return this.router.navigate(
        [`/leads/leads-managment/manage/${currentLead.id}`],
      );
    }
    
    const dialogRef = this.dialog.open(DublicatedLeadComponent, {
      width: '60%',
      height: '80%',
      data: { 
        email: currentLead.email,
        phoneNumber: currentLead.phoneNumber,
        prefix: currentLead.prefix,
        name: currentLead.name,
        lastName: currentLead.lastName 
      },
    });
  
    return new Promise<void>((resolve) => {
      dialogRef.afterClosed().subscribe(async (result) => {
        if (result?.success) {
          if (result?.isMerged) {
            if (Number(result?.id) === Number(this.id)) {
              this.duplicated = false;
              this.shouldResetTabs = true;
  
              const updatedLead = await firstValueFrom(this.leadsService.getOne(this.id));
              if (updatedLead) {
                this.leadSubject.next(updatedLead);
              }
              
              // IMPORTANT: Reload navigation after merge to reflect the updated lead list
              if (this.lastLeadRequest) {
                this.loadNavigation();
              }
            } else {
              // If merged into a different lead, navigate to that lead
              if(this.isModal){
                // For modal, load the merged lead and update navigation
                this.navigationLoading = true;
                this.leadsService.getOne(result.id).subscribe({
                  next: (lead) => {
                    this.leadSubject.next(lead);
                    this.id = result.id;
                    this.duplicated = lead?.isDuplicated || false;
                    this.last_activity_time = lead?.last_activity_time;
                    
                    // Reload navigation for the new lead
                    this.loadNavigation();
                  },
                  error: (error) => {
                    console.error('Error loading merged lead:', error);
                    this.navigationLoading = false;
                  }
                });
              } else {
                this.router.navigate([`/leads/leads-managment/manage/${result.id}`]);
              }
            }
          } else {
            // When keeping them separated (not merged)
            this.duplicated = false;
            
            // Update the lead object to reflect the resolved duplicate status
            const updatedLead = {
              ...currentLead,
              isDuplicated: false
            };
            this.setLeadDataAndSync(updatedLead);
            
            // Reload navigation in case the separation affects the lead list
            if (this.lastLeadRequest) {
              this.loadNavigation();
            }
          }
        }
        resolve();
      });
    });
  }

  
  updateOwner(event) {
    if (event && event.data) {
      let value = this.leadSubject.getValue();
      
      const lead_subscriptions = value?.lead_subscriptions || [];
      
      // Use findIndex to get the index (-1 if not found)
      const existingIndex = lead_subscriptions.findIndex(x => x && x.user_id === event.data?.representative?.id);
      

      let updatedSubscriptions = lead_subscriptions;
      
      // If not found (index === -1), add it
      if (existingIndex === -1) {
        if (event?.data?.subscription) {
          updatedSubscriptions = [...lead_subscriptions, event.data.subscription];
        }
      }
      this.leadSubject.next({
        ...value,
        lead_subscriptions: updatedSubscriptions,
        [event.type]: event?.data?.representative
      });
    }
  }


  navigateToPreviousLead() {
    if (this.previousId && !this.navigationLoading) {
      if (this.isModal) {
        // For modal, we need to update the current lead
        this.navigationLoading = true;
        
        // Emit navigation event to highlight row
        this.modalDataService.emitLeadNavigation(this.previousId);
        
        this.leadsService.getOne(this.previousId).subscribe({
          next: (lead) => {
            this.leadSubject.next(lead);
            this.id = this.previousId;
            this.duplicated = lead?.isDuplicated || false;
            this.last_activity_time = lead?.last_activity_time;
            // Reload navigation for the new lead
            this.loadNavigation();
          },
          error: (error) => {
            console.error('Error loading previous lead:', error);
            this.navigationLoading = false;
            
            // If the lead doesn't exist (e.g., was merged), reload navigation
            if (error.status === 404) {
              this.loadNavigation();
            }
          }
        });
      } else {
        this.router.navigate([`/leads/leads-managment/manage/${this.previousId}`]);
      }
    }
  }
  
  navigateToNextLead() {
    if (this.nextId && !this.navigationLoading) {
      if (this.isModal) {
        // For modal, we need to update the current lead
        this.navigationLoading = true;
        
        // Emit navigation event to highlight row
        this.modalDataService.emitLeadNavigation(this.nextId);
        
        this.leadsService.getOne(this.nextId).subscribe({
          next: (lead) => {
            this.leadSubject.next(lead);
            this.id = this.nextId;
            this.duplicated = lead?.isDuplicated || false;
            this.last_activity_time = lead?.last_activity_time;
            // Reload navigation for the new lead
            this.loadNavigation();
          },
          error: (error) => {
            console.error('Error loading next lead:', error);
            this.navigationLoading = false;
            
            // If the lead doesn't exist (e.g., was merged), reload navigation
            if (error.status === 404) {
              this.loadNavigation();
            }
          }
        });
      } else {
        this.router.navigate([`/leads/leads-managment/manage/${this.nextId}`]);
      }
    }
  }


  updateStopMessage(event){
    const currentLead = this.leadSubject.getValue();
    this.leadSubject.next({ ...currentLead,stop_messages:event }); // Clear the messages array
  }

  navigateToLeads(): void {
    this.router.navigate(['/leads/leads-managment']);
  }

  ngOnDestroy(): void {
    this.communicationService.resetSignal();
  
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  
    // ========== ADD THIS ==========
    // Clean up lead update subscription
    if (this.leadUpdateSubscription) {
      this.leadUpdateSubscription.unsubscribe();
    }
    // ==============================
  }

  closeModal() {
    if (this.isEmbedded) {
      // When embedded, emit close event instead of closing dialog
      this.closeDialog.emit(this.leadSubject.getValue());
    } else {
      // Original dialog closing logic
      this.communicationService.resetSignal();
      this.dialogRef.close(this.leadSubject.getValue());
    }
  }


private setupLeadUpdateListener(): void {
  // Clean up existing subscription
  if (this.leadUpdateSubscription) {
    this.leadUpdateSubscription.unsubscribe();
  }

  this.leadUpdateSubscription = this.socketService.getLeadUpdates()
    .subscribe((update) => {
      console.log('🔔 Lead update received in leads-managment:', update.type, 'leadId:', update.leadId, 'full payload:', update);
      const currentLead = this.leadSubject.getValue();

      // Only process updates for the current lead
      if (!currentLead || update.leadId !== currentLead.id) {
        console.log('⏭️ Skipping update - currentLead:', currentLead?.id, 'update.leadId:', update.leadId, 'types:', typeof currentLead?.id, typeof update.leadId);
        return;
      }

      console.log('📥 Processing lead update:', update.type);

      switch (update.type) {
        case 'step_changed':
          console.log('🔄 Step changed data:', update.data);
          this.handleStepUpdate(update.data, update.userId);
          break;
        case 'lead_updated':
          this.handleLeadInfoUpdate(update.data);
          break;
        // Notes are handled directly in NotesComponent
      }
    });
}

private handleStepUpdate(data: any, eventUserId: number): void {
  const currentLead = this.leadSubject.getValue();
  if (!currentLead) return;

  console.log('🔄 handleStepUpdate - old step:', currentLead.current_step_id, '→ new step:', data.current_step_id, 'step details:', data.step);

  const updatedLead = {
    ...currentLead,
    step: data.step,
    current_step_id: data.current_step_id,
    enrolled_at: data.enrolled_at,
    last_activity_time: data.last_activity_time,
    last_step_change: data.last_step_change,
    admission_status: data.admission_status,
    start_at: data.start_at,
    ...(data.status !== undefined && { status: data.status }),
  };

  console.log('✅ Setting updated lead locally with current_step_id:', updatedLead.current_step_id);
  this.setLeadDataLocally(updatedLead);
  this.last_activity_time = data.last_activity_time;

  if (this.isEmbedded || this.isModal) {
    this.modalDataService.emitLeadUpdate(updatedLead);
  }

  if (data?.step?.step_type === 'started') {
    this.celebrationService.celebrateWon();
  }
}

/**
 * Handle real-time lead info updates
 */
private handleLeadInfoUpdate(data: any): void {
  const currentLead = this.leadSubject.getValue();
  if (!currentLead) return;

  const updatedLead = { ...currentLead, ...data };
  this.setLeadDataLocally(updatedLead);
}

/**
 * Subscribe to lead room for real-time updates
 */
private subscribeToLeadRoom(leadId: number): void {
  // Avoid duplicate subscriptions
  if (this.currentSubscribedLeadId === leadId) {
    console.log('⚠️ Already subscribed to lead room:', leadId);
    return;
  }

  console.log('🔌 Subscribing to lead room:', leadId, 'Socket connected:', this.socketService.isConnected());
  this.currentSubscribedLeadId = leadId;
  this.socketService.subscribeToLead(leadId);

  // Setup listener after subscription
  this.setupLeadUpdateListener();
}

  // Call Bar Event Handlers removed - now handled by GlobalCallPanelComponent

  private extractErrorMessage(err: any): string {
    let msg = "Something went wrong";
  
    if (Array.isArray(err?.error?.message)) {
      msg = err.error.message.join(', ');
    } else if (typeof err?.error?.message === 'string') {
      msg = err.error.message;
    } else if (typeof err?.message === 'string') {
      msg = err.message;
    }
  
    return this.capitalizeFirst(msg);
  }

  private capitalizeFirst(str: string): string {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  getAdmissionStatus(lead: any): string {
    return lead?.admission_status || 'draft';
  }
  
  shouldShowDraftButtons(lead: any): boolean {
    const admStatus = this.getAdmissionStatus(lead);
    return admStatus === 'draft' && lead?.status !== 'Lost' && lead?.status !== 'Won';
  }
  
  shouldShowEnrolledButtons(lead: any): boolean {
    const admStatus = this.getAdmissionStatus(lead);
    return (admStatus === 'enrolled' || admStatus === 'pushed') 
        && lead?.status !== 'Lost' && lead?.status !== 'Won';
  }
  
  shouldShowReopen(lead: any): boolean {
    return lead?.status === 'Lost' || lead?.status === 'Won';
  }


  async enrollLead() {
    const currentLead = this.leadSubject.getValue();
  
    if (currentLead?.isDuplicated) {
      this.dialog.open(DialogComponent, {
        width: '400px',
        data: {
          header: 'Cannot Enroll',
          content: 'You cannot enroll this lead without first resolving the duplicate. Please merge or separate the duplicated leads first.',
          isInfo: true,
          type: 'warning'
        }
      });
      return;
    }
  
    if (this.stepper) {
      await this.stepper.enrollLead();
    }
  }

async markAsStarted() {
  const currentLead = this.leadSubject.getValue();

  if (currentLead?.isDuplicated) {
    this.dialog.open(DialogComponent, {
      width: '400px',
      data: {
        header: 'Cannot Mark as Started',
        content: 'You cannot mark this lead as Started without first resolving the duplicate.',
        isInfo: true,
        type: 'warning'
      }
    });
    return;
  }

  try {
    const response = await firstValueFrom(this.leadsService.markAsStarted(this.id));
    if (response) {
      const updatedLead = {
        ...this.leadSubject.getValue(),
        status: Status.WON,
        admission_status: 'started',
        current_step_id: response.current_step_id,
        step: response.step,
        last_activity_time: response.last_activity_time || new Date(),
        last_step_change: response.last_step_change || new Date(),
      };
      this.setLeadDataAndSync(updatedLead);
      this.celebrationService.celebrateWon();
    }
  } catch (err) {
    const msg = this.extractErrorMessage(err);
    this.notificationService.showNonErrorSnackBar(msg, 2500);
  }
}


// ─────────────────────────────────────────────────────────
//  6) pushDate()
// ─────────────────────────────────────────────────────────

async pushDate() {
  const currentLead = this.leadSubject.getValue();

  const dialogRef = this.dialog.open(EnrollmentModalComponent, {
    width: '400px',
    disableClose: true,
    data: {
      title: 'New Start Date',
      submitLabel: 'Save',
      start_at: currentLead?.start_at ? new Date(currentLead.start_at) : '',
      fa_advisor_id: currentLead?.fa_advisor_id ?? null,   // ← pre-select advisor
    }
  });

  const result = await firstValueFrom(dialogRef.afterClosed());
  if (!result) return;

  try {
    const response = await firstValueFrom(
      this.leadsService.pushDate(this.id, {
        start_at: result.start_at instanceof Date
          ? result.start_at.toISOString()
          : new Date(result.start_at).toISOString(),
        note: result.note || undefined,
      })
    );

    if (response) {
      const updatedLead = {
        ...this.leadSubject.getValue(),
        admission_status: 'pushed',
        start_at: response.start_at,
      };
      this.setLeadDataAndSync(updatedLead);
      this.notificationService.showNonErrorSnackBar('Start date updated', 2000);
    
      // Send note signal if note was created
      if (response?.note) {
        console.log('[LEAD-MGMT] Sending note-added-external signal');
        this.communicationService.sendOneTimeSignal({
          type: 'note-added-external',
          obj: { data: response.note },
        });
      } else {
        console.log('[LEAD-MGMT] No note in response — signal NOT sent');
      }
    
      // Open new activity modal for the pushed date
      this.activityLeadService.openActivityOnlyModal({
        detailed: true,
        hideCalendarProps: true,
        isExternal: true,
        defaultLead: this.id,
        leadView: true,
        isModal: true,
        hideNavigation: true,
        editMode: false,
        hourSegments: 30,
      });
    }
  } catch (err) {
    const msg = this.extractErrorMessage(err);
    this.notificationService.showNonErrorSnackBar(msg, 2500);
  }
}


// ─────────────────────────────────────────────────────────
//  7) markAsNotStarted()
//     FIX #1: Standard reason modal, no note field
// ─────────────────────────────────────────────────────────

async markAsNotStarted() {
  const currentLead = this.leadSubject.getValue();

  if (currentLead?.isDuplicated) {
    this.dialog.open(DialogComponent, {
      width: '400px',
      data: {
        header: 'Cannot Mark as Not Started',
        content: 'You cannot mark this lead as Not Started without first resolving the duplicate.',
        isInfo: true,
        type: 'warning'
      }
    });
    return;
  }

  const dialogRef = this.dialog.open(ReasonModalComponent, { width: '400px' });

  const result = await firstValueFrom(dialogRef.afterClosed());
  if (!result) return;

  try {
    const response = await firstValueFrom(
      this.leadsService.markAsNotStarted(this.id, {
        lost_reason: result.lost_reason,
        lost_comment: result.lost_comment,
      })
    );

    if (response) {
      const updatedLead = {
        ...this.leadSubject.getValue(),
        status: Status.LOST,
        admission_status: 'not_started',
        lost_comment: response.lost_comment,
      };
      this.setLeadDataAndSync(updatedLead);
    }
  } catch (err) {
    const msg = this.extractErrorMessage(err);
    this.notificationService.showNonErrorSnackBar(msg, 2500);
  }
}

  
}